import { useQuery } from "react-query";
import { internalApi } from "@circle-react/helpers/urlHelpers/internalApi";
import type { RecordType } from "../../types";

interface UseGeneralSearchOptions {
  enabled?: boolean;
}

interface GeneralSearchResponse {
  search_results: RecordType[];
}

interface UseGeneralSearchReturn {
  records: RecordType[];
}

export const useGeneralSearch = (
  query: string,
  { enabled = true }: UseGeneralSearchOptions = {},
): UseGeneralSearchReturn => {
  const { data } = useQuery<GeneralSearchResponse>(
    internalApi.search.communities.index({
      params: {
        query,
        exclude_posts: true,
        exclude_comments: true,
      },
    }),
    {
      enabled: enabled && !!query?.length,
    },
  );

  return {
    records: data?.search_results || [],
  };
};
